import { isPlainObject } from 'lodash';
import { ArrayUnitValue, Media, UnitValue } from '../types';
import { media } from '../styles/MediaQueries';
import { getValue } from './getValue';

export function setDeclaration(
  property: keyof CSSStyleDeclaration,
  value?: UnitValue | ArrayUnitValue | Media<UnitValue | ArrayUnitValue> | null | false,
  unit?: 'rem'
) {
  switch (value) {
    case undefined:
    case null:
    case false:
      return null;
  }

  const valueAsMedia = value as Media<UnitValue>;
  const valueAsUnitValue = value as UnitValue;

  return isPlainObject(value)
    ? {
        [property]: getValue(valueAsMedia.all, unit),

        [`@media ${media.desktop}`]: {
          [property]: getValue(valueAsMedia.desktop, unit)
        },

        [`@media ${media.mobile}`]: {
          [property]: getValue(valueAsMedia.mobile, unit)
        },

        [`@media ${media.tablesktop}`]: {
          [property]: getValue(valueAsMedia.tablesktop, unit)
        },

        [`@media ${media.tablet}`]: {
          [property]: getValue(valueAsMedia.tablet, unit)
        },

        [`@media ${media.phonablet}`]: {
          [property]: getValue(valueAsMedia.phonablet, unit)
        },

        [`@media ${media.phablet}`]: {
          [property]: getValue(valueAsMedia.phablet, unit)
        },

        [`@media ${media.phone}`]: {
          [property]: getValue(valueAsMedia.phone, unit)
        }
      }
    : {
        [property]: getValue(valueAsUnitValue, unit)
      };
}
